export default "__VITE_ASSET__CJPLGLZh__"